import { gql } from "@apollo/client";

export const GET_RUN_OBSERVABILITY_DATA = gql`
  query GetRunObservabilityData($stackId: ID!, $runId: ID!) {
    stack(id: $stackId) {
      id
      run(id: $runId) {
        id
        workerMetrics {
          states {
            runState
            failed
            duration {
              seconds
              p95Seconds
              p95Ratio
              p95Severity
            }
          }
          duration {
            seconds
            p95Ratio
            p95Severity
          }
          failedResources {
            count
          }
          comparison {
            runCount
            requiredRunCount
            windowDays
          }
        }
      }
    }
  }
`;
